import Network from 'infrastructure/js/modules/network';

export function update(dateQuery) {
  return Network.put(`asset-alert-setting/${dateQuery.id}` , dateQuery);
}

export function fetchAssetAlertSettingByType(dateQuery) {
  return Network.post('alert-setting-by-type', dateQuery);
}
